﻿window.cBuilderEmailWidgetCtrlNumberBox = function cBuilderEmailWidgetCtrlNumberBox(option) {
    var Me = this;

    // =========================================================
    // Héritage
    // =========================================================

    window.cBuilderEmailWidgetCtrl.call(this, option);


    // =========================================================
    // Propriétés spécifiques
    // =========================================================

    this.nomWidget = "dxwidgetformnumberbox"
    this.icone = "fas fa-9";
    this.nomBt = "Saisie d'un nombre";
    this.titleBt = "Permet de saisir un nombre"
    this.labelCtrl = "Saisissez un nombre"
    this.typeDevExpress = "dxNumberBox"


    // =========================================================
    // Surcharge mCreateElement
    // =========================================================

    var mCreateElementParent = this.mCreateElement;

    this.mCreateElement = function () {

        // Appel de la méthode du parent
        mCreateElementParent.call(Me);

        // =====================================================
        // AJOUT PERSONNEL DE LA CLASSE FILLE
        // =====================================================

        var $Td = Me.mGetTdSaisie();

        Me.mAddCtrlDevExpress()
    };

    this.mAddCtrlDevExpress = function (onValueChangedDevexpress) {
        Me.mGetTdSaisie().empty()
        var ctrl = $("<div class='ctrldevexpress " + Me.mGetTypeCtrlDevexpress() + " electrl" + Me.mGetIndexdevexpress() + " " + (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "obligatoire" : "") + "'/>").appendTo(Me.mGetTdSaisie()).dxNumberBox({
            label: (Me.mGetTdSaisie().attr("obligatoire") == "1" ? "* " : "") + Me.mGetTdSaisie().attr("label"),
            labelMode: "floating",
            stylingMode: "outlined", //pour voir la bordure
            format: "#0",
            step: 1,
            precision: 0,
            value:null,
            onValueChanged: function (e) {
                ctrl.element().css("background-color", "")
                ctrl.element().closest("td").css("border-left", "")
                if (onValueChangedDevexpress) onValueChangedDevexpress(ctrl, Me.mGetTdSaisie().attr("indexdevexpress"), Me.mGetTdSaisie().attr("tri"), Me.mGetTdSaisie().attr("typedevexpress"), "", Me.mGetTdSaisie().attr("typchamp"), Me.mGetTdSaisie().attr("label"), e.value)
            }
        }).dxNumberBox("instance")
        ctrl.isEmpty = function () { return (ctrl.option("value") == null) }
        return ctrl
    }


    // =========================================================
    // Surcharge mAddCtrlSaisie
    // =========================================================

    var mAddCtrlSaisieParent = this.mAddCtrlSaisie;

    this.mAddCtrlSaisie = function (contentElement) {

        // Appel de la méthode du parent
        mAddCtrlSaisieParent.call(Me, contentElement);
    };
};